import { useState, useEffect } from 'react'

type Breakpoint = 'xs' | 'md' | 'lg' | 'xl'

const getBreakpoint = (width: number): Breakpoint => {
  if (width >= 1440) return 'xl'
  if (width >= 1024) return 'lg'
  if (width >= 768) return 'md'
  return 'xs'
}

export const useBreakpoint = (): Breakpoint => {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(() =>
    typeof window !== 'undefined' ? getBreakpoint(window.innerWidth) : 'xs'
  )

  useEffect(() => {
    const handleResize = () => {
      const newBreakpoint = getBreakpoint(window.innerWidth)
      setBreakpoint(prev => (prev !== newBreakpoint ? newBreakpoint : prev))
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return breakpoint
}
